// © 2026 AttainIP Engineering
/**
 * App-root notice that this tab runs a superseded build (push spec M-12).
 * The check itself lives in `useBuildSkewCheck`; this only offers the reload.
 * Polite, not assertive: nothing has failed, and the user finishes what they
 * are doing before choosing to reload.
 */
import { useState } from 'react';
import { RefreshCw, X } from 'lucide-react';
import { useBuildSkewCheck } from '../hooks/useBuildSkewCheck';

export function UpdateAvailableNotice() {
  const superseded = useBuildSkewCheck();
  const [dismissed, setDismissed] = useState(false);
  if (!superseded || dismissed) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed bottom-0 inset-x-0 z-[100] flex justify-center px-ds-4 pb-ds-3 pointer-events-none"
    >
      <div className="pointer-events-auto flex items-center gap-ds-2 w-full max-w-[520px] bg-white border border-[#E7E5E4] rounded-ds-sm p-3 shadow-lg">
        <RefreshCw className="h-4 w-4 text-ds-text-secondary shrink-0" />
        <p className="flex-1 text-sm text-ds-text">A new version of Attain is available.</p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          className="shrink-0 rounded-[4px] border border-[#D6D3D1] bg-white px-[8px] py-[3px] text-[12px] font-medium text-[#1C1917] hover:bg-[#FAF9F7]"
        >
          Reload
        </button>
        <button
          type="button"
          onClick={() => setDismissed(true)}
          aria-label="Dismiss"
          className="shrink-0 text-ds-text-secondary hover:text-ds-text"
        >
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
}
